import { SystemConfig } from '../types';

export const PRINTER_CSS = `
    @media print {
        @page {
            margin: 0;
            padding: 0;
        }
        
        body {
            font-family: 'Courier New', Courier, monospace;
            width: 100%;
            margin: 0;
            padding: 0;
        }

        .printer-container {
            padding: 5px;
            box-sizing: border-box;
        }

        .w-80mm {
            width: 80mm;
        }

        .w-58mm {
            width: 58mm;
        }

        .text-center { text-align: center; }
        .text-left { text-align: left; }
        .text-right { text-align: right; }
        
        .font-bold { font-weight: bold; }
        .uppercase { text-transform: uppercase; }
        
        .text-2xl { font-size: 24px; }
        .text-xl { font-size: 18px; }
        .text-lg { font-size: 14px; }
        .text-base { font-size: 12px; }
        .text-sm { font-size: 10px; }

        .my-1 { margin-top: 4px; margin-bottom: 4px; }
        .my-2 { margin-top: 8px; margin-bottom: 8px; }
        .mb-2 { margin-bottom: 8px; }
        
        .border-t { border-top: 1px dashed black; }
        .border-b { border-bottom: 1px dashed black; }
        
        .flex { display: flex; }
        .justify-between { justify-content: space-between; }
        .items-center { align-items: center; }
        
        .hidden-print { display: none; }
    }
`;

export const generateReceiptHtml = (order: any, width: '58mm' | '80mm' = '80mm', config?: SystemConfig) => {
    const formatDate = (ts: number) => {
        return new Date(ts).toLocaleString('pt-BR', {
            day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit'
        });
    };

    const formatCurrency = (val: number) => {
        return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(val);
    };

    // Parse items if string
    let items = [];
    try {
        items = typeof order.items === 'string' ? JSON.parse(order.items) : order.items;
    } catch (e) {
        items = [];
    }

    return `
    <!DOCTYPE html>
    <html>
    <head>
        <title>Cupom Pedido #${order.id.slice(-4)}</title>
        <style>${PRINTER_CSS}</style>
    </head>
    <body>
        <div class="printer-container w-${width}">
            <div class="text-center mb-2">
                <div class="text-2xl font-bold">${config?.storeName || 'SAL ROTA'}</div>
                ${config?.businessAddress ? `<div class="text-sm">${config.businessAddress}</div>` : ''}
                ${config?.storePhone ? `<div class="text-sm">${config.storePhone}</div>` : ''}
                <div class="text-base">${formatDate(Date.now())}</div>
            </div>
            
            <div class="border-t border-b my-2 py-1">
                <div class="text-xl font-bold text-center">PEDIDO #${order.displayId || order.shortCode || order.id.slice(-4)}</div>
                <div class="text-center font-bold">${order.customerName}</div>
            </div>

            <div class="text-base mb-2">
                <div class="font-bold">ENDEREÇO DE ENTREGA:</div>
                <div>${order.address}</div>
                ${order.complement ? `<div>Comp: ${order.complement}</div>` : ''}
                ${order.reference ? `<div>Ref: ${order.reference}</div>` : ''}
                <div>${order.neighborhood}</div>
            </div>

            <div class="border-t my-2 pt-1">
                <div class="font-bold mb-1">ITENS DO PEDIDO:</div>
                ${Array.isArray(items) && items.length > 0 ? items.map((item: any) => `
                    <div class="flex justify-between text-base my-1">
                        <div style="flex: 1">
                            ${item.quantity || 1}x ${item.name || item}
                            ${item.notes ? `<div class="text-sm italic">Obs: ${item.notes}</div>` : ''}
                        </div>
                        <div class="text-right ml-2">${item.price ? formatCurrency(item.price * (item.quantity || 1)) : ''}</div>
                    </div>
                `).join('') : `
                    <div class="text-base my-1 whitespace-pre-wrap">${typeof order.items === 'string' ? order.items : 'Nenhum item detalhado'}</div>
                `}
            </div>

            <div class="border-t my-2 pt-1 text-right">
                <div class="flex justify-between">
                    <span>Subtotal:</span>
                    <span>${formatCurrency(order.orderValue)}</span>
                </div>
                <div class="flex justify-between">
                    <span>Taxa de Entrega:</span>
                    <span>${formatCurrency(order.deliveryFee)}</span>
                </div>
                <div class="flex justify-between font-bold text-xl my-1">
                    <span>TOTAL:</span>
                    <span>${formatCurrency(order.orderValue + order.deliveryFee)}</span>
                </div>
            </div>
            
            <div class="text-center text-base my-2 border-t pt-1">
                <div>Forma de Pagamento:</div>
                <div class="font-bold uppercase">${order.paymentMethod}</div>
                ${order.type === 'TAKEOUT' ? '<div class="font-bold my-1">RETIRADA NO BALCÃO</div>' : ''}
            </div>
            
            <div class="text-center text-sm mt-4">
                Impresso via SAL Rota
            </div>
        </div>
        <script>
            window.onload = function() {
                window.print();
                setTimeout(function(){ window.close(); }, 500);
            }
        </script>
    </body>
    </html>
    `;
};
